import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from './settings.service';
import { ComumModule } from './comum/comum.module';
import { UsuarioModule } from './usuario/usuario.module';
import { ClienteModule } from './cliente/cliente.module';
import { PontoFisicoModule } from './ponto-fisico/ponto-fisico.module';
import { SetorModule } from './setor/setor.module';
import { ProcessoModule } from './processo/processo.module';
import { RotinaModule } from './rotina/rotina.module';
import { RoteiroModule } from './roteiro/roteiro.module';
import { AuthModule } from './auth/auth.module';
import { PermissoesAcessoModule } from './permissoes-acesso/permissoes-acesso.module';
import { routing } from './rotas';
import { LoadingModule } from 'ngx-loading';
import { AppComponent } from './app.component';
import { ColetaModule } from './coleta/coleta.module';
import { ConstrucaoVariaveisModule } from './construcao-variaveis/construcao-variaveis.module';
import { HomeComponent } from './home/home.component';
import { IndicadorModule } from './indicador/indicador.module';
import { OcorrenciasModule } from './ocorrencias/ocorrencias.module';
import { RegiaoModule } from './regiao/regiao.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TabsModule, BsDropdownModule } from 'ngx-bootstrap';
import { DashboardsModule } from './dashboards/dashboards.module';
import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    HttpClientModule,
    UsuarioModule,
    ClienteModule,
    AuthModule,
    ComumModule,
    PontoFisicoModule,
    SetorModule,
    ProcessoModule,
    RotinaModule,
    RoteiroModule,
    PermissoesAcessoModule,
    RegiaoModule,
    OcorrenciasModule,
    IndicadorModule,
    ColetaModule,
    ConstrucaoVariaveisModule,
    DashboardsModule,
    NgbModule.forRoot(),
    routing,
    LoadingModule,
    TabsModule.forRoot(),
    NgbDropdownModule.forRoot(),
    ConfirmDialogModule,
    BsDropdownModule.forRoot()
  ],
  providers: [SettingsService, ConfirmationService, CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/app.module.ts